import axios from "axios";
import Swal from "sweetalert2";
import { useGoogleLogin } from "@react-oauth/google";
import { useNavigate } from "react-router-dom";

export default function GoogleVerifyAuthButton({ user, setUsererr }) {

    const navigate = useNavigate();

    const login = useGoogleLogin({
        flow: "implicit",

        onSuccess: async (tokenResponse) => {
            try {

                // Get Google user profile
                const googleUser = await axios.get(
                    "https://www.googleapis.com/oauth2/v3/userinfo",
                    {
                        headers: {
                            Authorization: `Bearer ${tokenResponse.access_token}`,
                        },
                    }
                );

                const resp = await axios.post(
                    process.env.REACT_APP_API + "/google-verify",
                    {
                        google_email: googleUser.data.email,
                        google_id: googleUser.data.sub,
                        picture: googleUser.data.picture,
                        user: user
                    }
                );

                if (resp.data.msgcode === 1) {

                    localStorage.setItem("pid", resp.data.profileid);
                    navigate("/dashboard");

                } else {

                    Swal.fire({
                        icon: "error",
                        title: "Google Login Failed",
                        text: resp.data.msg,
                        confirmButtonColor: "#900b06",
                    });

                }

            } catch (err) {

                Swal.fire({
                    icon: "error",
                    title: "Google Login Failed",
                    text:
                        err.response?.data?.msg ||
                        "Unable to login. Please try again.",
                    confirmButtonColor: "#900b06",
                });

            }
        },

        onError: () => {

            Swal.fire({
                icon: "error",
                title: "Cancelled",
                text: "Google Sign-In cancelled.",
            });

        },
    });

    const handleGoogleLogin = () => {

        const EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        const isPhone = /^\d{10}$/.test(user);

        const isEmail = EMAIL.test(user);

        if (!isPhone && !isEmail) {

            setUsererr(true);

            Swal.fire({
                icon: "error",
                title: "Validation Error",
                text: "Please enter your registered Mobile Number or Email ID.",
                confirmButtonColor: "#900b06",
            });

            return;
        }

        login(); // Google popup opens only after validation
    };

    return (
        <div className="d-flex justify-content-center mt-3">
            <button
                type="button"
                onClick={handleGoogleLogin}
                className="btn bg-white border shadow-sm d-flex align-items-center justify-content-center"
                style={{
                    width: "350px",
                    height: "44px",
                    borderRadius: "22px",
                    fontWeight: "500",
                    color: "#3c4043",
                    border: "1px solid #dadce0",
                }}
            >
                <img
                    src="https://developers.google.com/identity/images/g-logo.png"
                    alt="Google"
                    width="20"
                    height="20"
                    className="me-2"
                />
                Verify with Google
            </button>
        </div>
    );
}